import theme from '../../theme';
import { styled } from '@mui/material/styles';
import { Chip, ChipProps } from '@mui/material';

const colorChipPrimary = theme.palette.primary.main;
const colorChipSecondary = theme.palette.secondary.main;

export const ChipStyled = styled(Chip)<ChipProps>(({ theme }) => ({
  '&.MuiChip-root': {
    fontWeight: 600,
    fontSize: '0.75rem',
    padding: theme.spacing(0.5),
  },
  '&.MuiChip-colorPrimary': {
    backgroundColor: colorChipPrimary,
  },
  '&.MuiChip-outlinedPrimary': {
    color: colorChipPrimary,
    border: `1px solid ${colorChipPrimary}`,
  },
  '&.MuiChip-colorSecondary': {
    backgroundColor: colorChipSecondary,
  },
  '&.MuiChip-outlinedSecondary': {
    color: colorChipSecondary,
    border: `1px solid ${colorChipSecondary}`,
  },
  '&.MuiChip-outlined': {
    background: 'transparent',
  },
}));
